import * as React from "react";
import { Languages, LanguageType } from "models";

// Material UI
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

// Utils
import { Row } from "layout";

// Styling
import { withStyles, Theme, WithStyles, createStyles } from "@material-ui/core/styles";
import { SIMPLE_MENU_INDEX } from "layers";

const styles = ({ palette, spacing }: Theme) =>
    createStyles({
        container: {
            display: "flex",
            flexWrap: "wrap",
        },
        select: {
            minWidth: 120,
        },
        formControl: {
            margin: 5,
            minWidth: 120,
            maxWidth: 300,
            zIndex: SIMPLE_MENU_INDEX,
        },
    });

interface LanguageFilterProps extends React.Props<any> {
    currentLanguage: LanguageType;
    languages: LanguageType[];
    onLanguageChangeCallback: (event: any) => void;
}

const languageFilters = (props: LanguageFilterProps & WithStyles<typeof styles>) => (
    <FormControl className={props.classes.formControl}>
        <Select
            value={props.currentLanguage ? props.currentLanguage : -1}
            onChange={props.onLanguageChangeCallback}
            input={<Input id="language" />}
        >
            {props.languages.map((language) => (
                <MenuItem key={language} value={language}>
                    <Row xs="middle">
                        <img
                            src={Languages.imageForLanguage(language)}
                            style={{ height: 25, paddingLeft: 10, paddingRight: 5 }}
                        />
                        <Typography variant="body1">{Languages.getLanguageFriendlyString(language)}</Typography>
                    </Row>
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

export const LanguageFilters = withStyles(styles)(languageFilters);
